module.exports = function getResource(label, vars = []) {
    let resources = {
        happening: 'En cours chez Sephora',
        find: 'Trouver un Sephora'
    };

    return resources[label];
};
